import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Firebase配置对象
const firebaseConfig = {
  apiKey: "AIzaSyAYKcorJ3Uekl6a-L91woXsCYETbXIxcAY",
  authDomain: "ai-poetry-96c8f.firebaseapp.com",
  projectId: "ai-poetry-96c8f",
  storageBucket: "ai-poetry-96c8f.appspot.com",
  messagingSenderId: "513972370537",
  appId: "1:513972370537:web:b546a8c4336ff74ad376f8",
  measurementId: "G-H1S84525JT",
};

// 初始化Firebase
const app = initializeApp(firebaseConfig);

// 初始化Analytics
const analytics = getAnalytics(app);

// 确保analytics被正确导出
export { app, analytics };
